import { GapChaseFilterBase, filterType, dataType } from '../../GapChaseFilterBase';
import Axios from 'axios';

export default class PcpChaseTypeFilter extends GapChaseFilterBase {
    constructor() {
        super();
        this.id = 41;
        this.name = "PCP Chase Type";
        this.filterName = "PcpChaseType";
        //this.isHidden = true;
        this.filterType = filterType.checkbox;
        this.values = [
            {
                "label": "",
                "value": "PCPChaseType"
            }
        ];

        this.dataType = dataType.boolean;
        this.filterCategory = "Provider Level";
        this.filterGroupId = 4;
        this.placeholder = "PCP Chase Type";

    }

}
